// Display metadata for the 18 leaf AI Trust Signals the buyer judge evaluates
// (keys 1, 3-16, 18-20; #2 HTTPS and #17 Google-Page-1 are scanner-verified, not
// LLM-judgable - see jarts/app/signals.py). The judge already carries each
// signal's `name` inline on the judgment, so this map exists ONLY to group the
// exposure pills into the three buyer-facing buckets the prototype shows
// (Foundation / Authority / Brand). Names here are a fallback for the rare row
// that surfaces a key without a name.

export type SignalGroup = "foundation" | "authority" | "brand";

export const SIGNAL_GROUP_LABELS: Record<SignalGroup, string> = {
  foundation: "Foundation",
  authority: "Authority",
  brand: "Brand",
};

/** Fixed render order for the grouped exposure panel. */
export const SIGNAL_GROUP_ORDER: SignalGroup[] = ["foundation", "authority", "brand"];

interface SignalMeta {
  name: string;
  group: SignalGroup;
}

/** key → {name, group}. Grouping is a display convenience, not a backend
 *  concept: on-page / structural signals are "Foundation", reputation /
 *  off-site signals are "Authority", and trust / values signals are "Brand". */
export const SIGNAL_META: Record<number, SignalMeta> = {
  1: { name: "Verified NAP Consistency", group: "foundation" },
  3: { name: "On-Page Pricing Transparency", group: "foundation" },
  5: { name: "On-Page Content Richness", group: "foundation" },
  6: { name: "Advanced Schema Deployment", group: "foundation" },
  7: { name: "Answer-Focused Semantic Structure", group: "foundation" },
  11: { name: "On-Page Contact & 'About' Depth", group: "foundation" },
  12: { name: "On-Page Policy & Ethics Transparency", group: "foundation" },
  16: { name: "Content Freshness", group: "foundation" },
  4: { name: "Public Review Score & Volume", group: "authority" },
  8: { name: "Presence of Author/Team Pages", group: "authority" },
  9: { name: "Educational Content Hub", group: "authority" },
  10: { name: "Case Study & Testimonial Presence", group: "authority" },
  13: { name: "Claims of Industry Recognition", group: "authority" },
  14: { name: "Content Surface Area", group: "authority" },
  15: { name: "Authoritative Outbound Citations", group: "authority" },
  18: { name: "Accuracy of Claims", group: "brand" },
  19: { name: "Brand Values", group: "brand" },
  20: { name: "Customer Responsiveness", group: "brand" },
};

/** All judged keys in their grouped display order. Drives the "absent" pills. */
export const SIGNAL_KEYS_BY_GROUP: Record<SignalGroup, number[]> = {
  foundation: [1, 3, 5, 6, 7, 11, 12, 16],
  authority: [4, 8, 9, 10, 13, 14, 15],
  brand: [18, 19, 20],
};

export function signalName(key: number, inlineName?: string): string {
  return (inlineName && inlineName.trim()) || SIGNAL_META[key]?.name || `Signal ${key}`;
}
